import PropTypes from 'prop-types';

export const batchSizeType = PropTypes.shape({
  bytes: PropTypes.number,
  fileSize: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
});

export const imageSizeType = PropTypes.shape({
  availability: PropTypes.string,
  bytes: PropTypes.number,
  contentType: PropTypes.string,
  currencyCode: PropTypes.string,
  description: PropTypes.string,
  discountPrice: PropTypes.string,
  dpi: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  fileSize: PropTypes.string,
  hasFileSize: PropTypes.bool,
  imagePackSavings: PropTypes.arrayOf(
    PropTypes.shape({
      sku: PropTypes.string,
      packSize: PropTypes.number,
      packPrice: PropTypes.number,
      pricePerDownload: PropTypes.number,
      totalAmountSaved: PropTypes.number,
      savingsPerDownload: PropTypes.number,
    })
  ),
  label: PropTypes.string,
  localeUnits: PropTypes.string,
  megapixels: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  name: PropTypes.string,
  pixels: PropTypes.string,
  price: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.object,
  ]),
  rawPrice: PropTypes.number,
  rawOriginalPrice: PropTypes.number,
  teeShirtSize: PropTypes.string,
  uncompressedFileSize: PropTypes.string,
});

export const filmSizeType = PropTypes.shape({
  availability: PropTypes.string,
  bytes: PropTypes.number,
  codec: PropTypes.string,
  compression: PropTypes.string,
  contentType: PropTypes.string,
  currencyCode: PropTypes.string,
  definition: PropTypes.string,
  description: PropTypes.string,
  discountPrice: PropTypes.string,
  dpi: PropTypes.string,
  fileSize: PropTypes.string,
  frameRate: PropTypes.number,
  hasFileSize: PropTypes.bool,
  imagePackSavings: PropTypes.arrayOf(
    PropTypes.shape({
      sku: PropTypes.string,
      packSize: PropTypes.number,
      packPrice: PropTypes.number,
      pricePerDownload: PropTypes.number,
      totalAmountSaved: PropTypes.number,
    })
  ),
  label: PropTypes.string,
  localeUnits: PropTypes.string,
  megapixels: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  name: PropTypes.string,
  pixels: PropTypes.string,
  price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  rawPrice: PropTypes.number,
  rawOriginalPrice: PropTypes.number,
});
export interface FilmSize {
  availability?: string;
  bytes?: number;
  codec: string;
  compression?: string;
  contentType: string;
  currencyCode?: string;
  definition: string;
  description?: string;
  discountPrice?: string;
  dpi?: string;
  fileSize?: string;
  frameRate: number;
  hasFileSize?: boolean;
  imagePackSavings?: Array<{
    sku: string;
    packSize: number;
    packPrice: number;
    pricePerDownload: number;
    totalAmountSaved: number;
  }>;
  label: string;
  localeUnits?: string;
  megapixels?: number | string;
  name?: string;
  pixels?: string;
  price?: number | string;
  rawPrice?: number;
  rawOriginalPrice?: number;
  pixelWidth?: number;
  pixelHeight?: number;
  license?: string;
  teeShirtSize?: string;
  sortOrder?: number;
}

export interface ImageSize extends Omit<FilmSize, 'frameRate'> {
  uncompressedFileSize?: string;
}

export const licenseSizeType = PropTypes.shape({
  license: PropTypes.string,
});
